import { NODE_ENV } from 'constants/runtimeConfig';

export const isTest = NODE_ENV === 'test';
export const isDev = NODE_ENV === 'development';
export const isProduction = NODE_ENV === 'production';
export const isDevOrTest = isTest || isDev;

export const SENTRY_ENABLED = !isDevOrTest;
export const ENVIRONMENT = NODE_ENV;
